import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import quartOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(quartOfYear);

export interface MyProductIncomeSliceType {
  showTypeList: {
    value: string;
    label: string;
    active: boolean;
  }[];
  targetFilter: {
    value: string;
    label: string;
    active: boolean;
  }[];
  sortFilterList: {
    value: string;
    label: string;
    active: boolean;
  }[];
  sortFilterListHFH: {
    value: string;
    label: string;
    active: boolean;
  }[];
  targetFilterHFH: {
    value: string;
    label: string;
    active: boolean;
  }[];
  inputKeyFilter: string;
  myProductIncomeDate: Date;
  myProductIncomeQuarterDate: Date;
  myProductIncomeHalfYearDate: Date;
  myProductIncomeYearDate: Date;
}
export const MyProductIncomeSlice = createSlice({
  name: "MyProductIncomeSlice",
  initialState: {
    showTypeList: [
      { value: "simple", label: "简洁模式", active: false },
      { value: "detail", label: "详尽模式", active: true },
    ],
    sortFilterList: [
      { value: "goalAmt", label: "目标业绩", active: false },
      { value: "goalIncome", label: "目标收入", active: false },
      { value: "predictAmt", label: "预期业绩", active: false },
      { value: "predictIncome", label: "预期收入", active: false },
      { value: "actualAmt", label: "当前业绩", active: false },
      { value: "actualIncome", label: "当前收入", active: true },
      { value: "gapAmt", label: "业绩差距", active: false },
      { value: "gapIncome", label: "收入差距", active: false },
    ],
    targetFilter: [
      { value: "goalAmt", label: "目标业绩", active: true },
      { value: "goalIncome", label: "目标收入", active: true },
      { value: "predictAmt", label: "预期业绩", active: true },
      { value: "predictIncome", label: "预期收入", active: true },
      { value: "gapAmt", label: "业绩差距", active: true },
      { value: "gapIncome", label: "收入差距", active: true },
      { value: "actualAmt", label: "当前业绩", active: true },
      { value: "actualIncome", label: "当前收入", active: true },
    ],
    // sort 黄飞红
    sortFilterListHFH: [
      { value: "goalAmt", label: "目标业绩", active: false },
      { value: "actualAmt", label: "当前业绩", active: true },
      { value: "stockAmt", label: "同期业绩", active: false },
      { value: "doneRate", label: "达成率", active: false },
    ],
    // target 黄飞红
    targetFilterHFH: [
      { value: "goalAmt", label: "目标业绩", active: true },
      { value: "actualAmt", label: "当前业绩", active: true },
      { value: "stockAmt", label: "同期业绩", active: true },
      { value: "doneRate", label: "达成率", active: true },
    ],
    inputKeyFilter: "",
    myProductIncomeDate: new Date(),
    myProductIncomeQuarterDate: dayjs().endOf("quarter").toDate(),
    myProductIncomeHalfYearDate: dayjs().month() < 6 ? dayjs().month(5).endOf("month").toDate() : dayjs().month(11).endOf("month").toDate(),
    myProductIncomeYearDate: dayjs().endOf("year").toDate(),
  },
  reducers: {
    updateshowTypeList(state, action) {
      state.showTypeList = action.payload;
    },
    updatesortFilterList(state, action) {
      state.sortFilterList = action.payload;
    },
    updatesortFilterListHFH(state, action) {
      state.sortFilterListHFH = action.payload;
    },
    updatetargetFilterHFH(state, action) {
      state.targetFilterHFH = action.payload;
    },
    updatetargetFilter(state, action) {
      state.targetFilter = action.payload;
    },
    updateInputKeyFilter(state, action) {
      state.inputKeyFilter = action.payload;
    },
    updateMyProductIncomeQuarterDate(state, action) {
      state.myProductIncomeQuarterDate = action.payload;
    },
    updateMyProductIncomeDate(state, action) {
      state.myProductIncomeDate = action.payload;
    },
    updateMyProductIncomeHalfYearDate(state, action) {
      state.myProductIncomeHalfYearDate = action.payload;
    },
    updateMyProductIncomeYearDate(state, action) {
      state.myProductIncomeYearDate = action.payload;
    },
  },
});

const { actions, reducer } = MyProductIncomeSlice;
export const {
  updateshowTypeList,
  updatesortFilterList,
  updatetargetFilter,
  updateInputKeyFilter,
  updateMyProductIncomeQuarterDate,
  updateMyProductIncomeDate,
  updateMyProductIncomeHalfYearDate,
  updateMyProductIncomeYearDate,
  updatesortFilterListHFH,
  updatetargetFilterHFH,
} = actions;
export default reducer;
